import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/incidencia-parametros/';
/**
 * GET Incidencia Parametros
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasParametrosPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Incidencia Parametros
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasParametros = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Parametros
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaParametro = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Parametros
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaParametro = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Parametros
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaParametro = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Parametros
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaParametro = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia Parametros
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaParametro = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
